<mat-card class="output-row" [ngClass]="{'selected-row': isSelected}" (click)="handleClick(output)">

  <div class="table-item" *ngFor="let column of displayColumns" [ngSwitch]="column.code">
    <div *ngSwitchCase="'outputGroupName'">{{groupName}}</div>
    <div *ngSwitchCase="'status'">
      <app-output-locking-status [isLocking]="output.isLocking" [isUnlocking]="output.isUnlocking" [status]="output.status">
      </app-output-locking-status>
    </div>
    <div *ngSwitchCase="'name'" class="item-name" matTooltip="{{output[column.code]}}">
      {{output[column.code]}}
    </div>
    <div *ngSwitchCase="'monitorStatus'">
      <app-output-opening-status [status]="output.status">
      </app-output-opening-status>
    </div>
    <div *ngSwitchCase="'type'">
      <span *ngIf="column.code === 'type'" class="margin__left--5 margin__right--5"
            [ngClass]="{'icon-open': output.type === outputType.Door,'light-theme-icon': (isDarkTheme$ | async) === (false || null || undefined)}"></span>
      <span>{{output[column.code]}}</span>
    </div>
    <div *ngSwitchDefault>{{output[column.code]}}</div>
  </div>
</mat-card>
